import Component from 'vue-class-component';

const routerHooks = [
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
];

Component.registerHooks(routerHooks);
